import ConcurrerTags from './ConcurrerTags'
import ApproverTags from './ApproverTags'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { useFDCNotificationsContext } from '../FDCNotificationsContext'

const FDCNotificationEventPrefix: React.FC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  const { approverEvents, concurrerEvents } = useFDCNotificationsContext()
  if (concurrerEvents.some((concurrerEvent) => concurrerEvent.id === event.id))
    return <ConcurrerTags />
  else if (
    approverEvents.some((approverEvent) => approverEvent.id === event.id)
  )
    return <ApproverTags />
  return null
}

export default FDCNotificationEventPrefix
